import React from 'react';
import Skeleton from 'react-loading-skeleton';

interface FragmentFallbackProps {
    title: string;
}

export const FragmentFallback: React.FC<FragmentFallbackProps> = ({ title }): React.ReactElement => {
    return (
        <>
            <h2>Loading {title}</h2>
            <p>Please wait...</p>
            <Skeleton />
        </>
    );
};
